import {
  CART_ADD_ITEM,
  CART_CLEAR,
  CART_REPLACE_ITEMS,
  CART_REMOVE_ITEM,
  CART_UPDATE_QUANTITY,
} from './actionTypes';

const initialState = {
  items: [],
};

const getCartKey = (item = {}) => item.cartKey || `${item.itemType || 'product'}:${item.id}`;

export default function cartReducer(state = initialState, action) {
  switch (action.type) {
    case CART_ADD_ITEM: {
      const product = action.payload?.product || {};
      const quantity = Number(action.payload?.quantity || 1);
      const incoming = {
        itemType: product.itemType || 'product',
        ...product,
        quantity,
      };
      const incomingKey = getCartKey(incoming);
      const existing = state.items.find((item) => getCartKey(item) === incomingKey);

      if (existing) {
        return {
          ...state,
          items: state.items.map((item) =>
            getCartKey(item) === incomingKey
              ? { ...item, quantity: Number(item.quantity || 0) + quantity }
              : item
          ),
        };
      }

      return {
        ...state,
        items: [...state.items, incoming],
      };
    }

    case CART_REMOVE_ITEM:
      return {
        ...state,
        items: state.items.filter((item) => {
          const key = getCartKey(item);
          return key !== action.payload && item.id !== action.payload;
        }),
      };

    case CART_UPDATE_QUANTITY: {
      const nextQty = Math.max(1, Number(action.payload?.quantity || 1));
      return {
        ...state,
        items: state.items.map((item) =>
          getCartKey(item) === action.payload?.id || item.id === action.payload?.id
            ? { ...item, quantity: nextQty }
            : item
        ),
      };
    }

    case CART_CLEAR:
      return {
        ...state,
        items: [],
      };

    case CART_REPLACE_ITEMS:
      return {
        ...state,
        items: Array.isArray(action.payload?.items) ? action.payload.items : [],
      };

    default:
      return state;
  }
}
